import { APIResponse } from './api-response.type';
import { StatusValues } from './common.types';

export enum AutoModeSpeed {
  FAST = 'fast',
  MEDIUM = 'medium',
  SLOW = 'slow'
}

export enum AutoModeComplexity {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum AutoModeCost {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export type TAIChatModel = {
  _id?: string;
  platform: string;
  aiModelName: string;
  publicName: string;
  description: string;
  enabledForFree: boolean;
  imageGeneration: boolean,
  fileAnalysis: boolean;
  realTimeData: boolean;
  icon: string;
  autoModeStrengths: string[];
  autoModeSpeed: AutoModeSpeed;
  autoModeComplexity: AutoModeComplexity;
  autoModeCost: AutoModeCost;
  autoModeEnabled: boolean;
  reasoning: boolean;
  usageMultiplier: number;
  status: StatusValues;
  createdAt?: Date;
  updatedAt?: Date;
};

export interface CreateAiChatModelResponse extends APIResponse {
  data: {
    model: TAIChatModel;
  } | null;
}


export interface AiChatModelsResponse extends APIResponse {
  data: {
    models: TAIChatModel[];
  } | null;
}